import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const producerImporterSelectors = importerSelectors(
  'producer.importer',
);

export default producerImporterSelectors;
